"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _LoadingScreen = _interopRequireDefault(require("./LoadingScreen.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LoadingScreenWrapper = _styledComponents.default.div.withConfig({
  displayName: "LoadingScreen__LoadingScreenWrapper",
  componentId: "sc-1lr41wn-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:99999;opacity:0.8;background:", ";display:grid;text-align:center;place-items:center;"], function (_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.backgroundColor;
  return theme.colors[backgroundColor];
});

var LoadingScreenDisplayWrapper = _styledComponents.default.div.withConfig({
  displayName: "LoadingScreen__LoadingScreenDisplayWrapper",
  componentId: "sc-1lr41wn-1"
})([""]);

var LoadingScreen = function LoadingScreen(props) {
  var show = props.show,
      backgroundColor = props.backgroundColor,
      primaryText = props.primaryText,
      secondaryText = props.secondaryText,
      primaryTextConfig = props.primaryTextConfig,
      secondaryTextConfig = props.secondaryTextConfig,
      spinnerConfig = props.spinnerConfig,
      accessible = props.accessible,
      theme = props.theme,
      customProperties = props.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return show && /*#__PURE__*/_react.default.createElement(LoadingScreenWrapper, (0, _extends2.default)({
      backgroundColor: backgroundColor
    }, customProperties), /*#__PURE__*/_react.default.createElement(LoadingScreenDisplayWrapper, null, /*#__PURE__*/_react.default.createElement(_Spinner.default, (0, _extends2.default)({
      theme: theme
    }, spinnerConfig)), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
      theme: theme,
      accessible: accessible
    }, primaryTextConfig), primaryText), secondaryText && /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
      theme: theme,
      accessible: accessible
    }, secondaryTextConfig), secondaryText)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

LoadingScreen.propTypes = _LoadingScreen.default.PropTypes;
LoadingScreen.defaultProps = _LoadingScreen.default.DefaultProps;
var _default = LoadingScreen;
exports.default = _default;